module.exports = __webpack_public_path__ + "static/media/2 samurai tattoo oni hanya demon mask warrior japanese tattoo.1280x1707.ea77ddfa.webp";